'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Search = function (_Component) {
    _inherits(Search, _Component);

    function Search() {
        _classCallCheck(this, Search);

        var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));

        _this.state = { value: '' };
        _this.handleChange = function (e) {
            var onChange = _this.props.onChange;

            _this.setState({ value: e.target.value });
            if (onChange) {
                onChange(e);
            }
        };
        _this.handleSubmit = function (e) {
            var onSubmit = _this.props.onSubmit;

            e.preventDefault();
            if (onSubmit) {
                onSubmit(e);
            }
        };
        return _this;
    }

    _createClass(Search, [{
        key: 'render',
        value: function render() {
            var className = this.props.className;
            var value = this.state.value;

            return _react2.default.createElement("form", { className: className, onSubmit: this.handleSubmit }, _react2.default.createElement("div", { className: "luna-inset luna-inset--small" }, _react2.default.createElement("input", { className: "luna-input", type: "text", "aria-label": "Search", placeholder: "Search", value: value, onChange: this.handleChange }), _react2.default.createElement("button", { className: "luna-inset__action", type: "submit", "aria-label": "Search" }, _react2.default.createElement("svg", { className: "luna-icon luna-icon--small", "aria-hidden": "true" }, _react2.default.createElement("path", { d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" }), _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })))));
        }
    }]);

    return Search;
}(_react.Component);

Search.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    onSubmit: _propTypes2.default.func.isRequired,
    className: _propTypes2.default.string.isRequired
};
exports.default = Search;
//# sourceMappingURL=Search.js.map